module.exports = __webpack_public_path__ + "img/img3.7007edba.jpg";